import React, { FC } from 'react';

import { AllRoutes } from 'constants/routes';
import GeneralLayout from 'core/react/layout/GeneralLayout';
import PagePanel from 'core/react/general/panel/PagePanel';
import { DetectorsPageStyled } from 'ui/pages/attribute-range-detectors/detectors-page.styled';
import { AttributeRangeDetectors } from 'components/organisms/attribute-range-detectors';

const AttributeRangeDetectorsPage: FC = () => (
  <GeneralLayout>
    <DetectorsPageStyled>
      <PagePanel>
        <AttributeRangeDetectors />
      </PagePanel>
    </DetectorsPageStyled>
  </GeneralLayout>
);

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
AttributeRangeDetectorsPage.Url = AllRoutes.AttributeRangeDetectors;

export default AttributeRangeDetectorsPage;
